import { getHandler, patchHandler, postHandler } from 'src/utils/fetchHandler';
import { getAuthHost } from 'src/utils/getAuthHost';
import { getPendingAuthUserUpdate } from './authUser.selector';

export const CLEAR_AUTH_USERS = 'CLEAR_AUTH_USERS/AUTH_USER/@WISELY/WEB';
export const CLEAR_AUTH_USER_UPDATE_ERRORS = 'CLEAR_AUTH_USER_UPDATE_ERRORS/AUTH_USER/@WISELY/WEB';
export const CLEAR_AUTH_USER_CREATE_ERRORS = 'CLEAR_AUTH_USER_CREATE_ERRORS/AUTH_USER/@WISELY/WEB';
export const GET_AUTH_USER = 'GET_AUTH_USER/AUTH_USER/@WISELY/WEB';
export const GET_AUTH_USERS = 'GET_AUTH_USERS/AUTH_USER/@WISELY/WEB';
export const FETCH_AUTH_USER_FAILED = 'FETCH_AUTH_USER_FAILED/AUTH_USER/@WISELY/WEB';
export const FETCH_AUTH_USER_SUCCEEDED = 'FETCH_AUTH_USER_SUCCEEDED/AUTH_USER/@WISELY/WEB';
export const FETCH_AUTH_USERS_FAILED = 'FETCH_AUTH_USERS_FAILED/AUTH_USER/@WISELY/WEB';
export const FETCH_AUTH_USERS_SUCCEEDED = 'FETCH_AUTH_USERS_SUCCEEDED/AUTH_USER/@WISELY/WEB';
export const UPDATE_AUTH_USER = 'UPDATE_AUTH_USER/AUTH_USER/@WISELY/WEB';
export const UPDATE_AUTH_USER_FAILED = 'UPDATE_AUTH_USER_FAILED/AUTH_USER/@WISELY/WEB';
export const UPDATE_AUTH_USER_SUCCEEDED = 'UPDATE_AUTH_USER_SUCCEEDED/AUTH_USER/@WISELY/WEB';
export const CREATE_AUTH_USER = 'CREATE_AUTH_USER/AUTH_USER/@WISELY/WEB';
export const CREATE_AUTH_USER_FAILED = 'CREATE_AUTH_USER_FAILED/AUTH_USER/@WISELY/WEB';
export const CREATE_AUTH_USER_SUCCEEDED = 'CREATE_AUTH_USER_SUCCEEDED/AUTH_USER/@WISELY/WEB';
export const REFRESH_CONFIRMATION_CODE = 'REFRESH_CONFIRMATION_CODE/AUTH_USER/@WISELY/WEB';
export const REFRESH_CONFIRMATION_CODE_FAILED =
	'REFRESH_CONFIRMATION_CODE_FAILED/AUTH_USER/@WISELY/WEB';
export const REFRESH_CONFIRMATION_CODE_SUCCEEDED =
	'REFRESH_CONFIRMATION_CODE_SUCCEEDED/AUTH_USER/@WISELY/WEB';

export const clearAuthUsers = () => ({
	type: CLEAR_AUTH_USERS,
});

export const clearAuthUserUpdateErrors = () => ({
	type: CLEAR_AUTH_USER_UPDATE_ERRORS,
});

export const clearAuthUserCreateErrors = () => ({
	type: CLEAR_AUTH_USER_CREATE_ERRORS,
});

export const getAuthUser = () => ({
	type: GET_AUTH_USER,
});

export const getAuthUsers = () => ({
	type: GET_AUTH_USERS,
});

export const fetchAuthUserFailed = payload => ({
	type: FETCH_AUTH_USER_FAILED,
	payload,
});

export const fetchAuthUserSucceeded = payload => ({
	type: FETCH_AUTH_USER_SUCCEEDED,
	payload,
});

export const fetchAuthUsersFailed = payload => ({
	type: FETCH_AUTH_USERS_FAILED,
	payload,
});

export const fetchAuthUsersSucceeded = payload => ({
	type: FETCH_AUTH_USERS_SUCCEEDED,
	payload,
});

export const fetchAuthUser = (id, params, suppressAuth = false) => {
	return dispatch => {
		dispatch(getAuthUser());
		const path = `users/${id}`;

		return getHandler(path, params, getAuthHost(), suppressAuth)
			.then(json => dispatch(fetchAuthUserSucceeded(json)))
			.catch(error => {
				console.error('fetchAuthUser error', error);
				dispatch(fetchAuthUserFailed());
			});
	};
};

export const fetchAuthUsers = params => {
	return async dispatch => {
		dispatch(getAuthUsers());
		const path = 'users';

		return getHandler(path, params, getAuthHost())
			.then(json => dispatch(fetchAuthUsersSucceeded(json)))
			.catch(error => {
				console.error('fetchAuthUsers error', error);
				dispatch(fetchAuthUsersFailed(error));
			});
	};
};

export const updateAuthUser = () => ({
	type: UPDATE_AUTH_USER,
});

export const requestUpdateAuthUserFailed = payload => ({
	type: UPDATE_AUTH_USER_FAILED,
	payload,
});

export const requestUpdateAuthUserSucceeded = payload => ({
	type: UPDATE_AUTH_USER_SUCCEEDED,
	payload,
});

export const requestUpdateAuthUser = (id, body, suppressAuth = false) => {
	return async (dispatch, getState) => {
		if (getPendingAuthUserUpdate(getState())) {
			return;
		}
		dispatch(updateAuthUser());
		const path = `users/${id}`;

		return patchHandler(path, JSON.stringify(body), null, getAuthHost(), suppressAuth)
			.then(json => dispatch(requestUpdateAuthUserSucceeded(json)))
			.catch(error => {
				console.error('requestUpdateAuthUser error', error);
				dispatch(requestUpdateAuthUserFailed(error));
			});
	};
};

export const createAuthUser = () => ({
	type: CREATE_AUTH_USER,
});

export const requestCreateAuthUserFailed = payload => ({
	type: CREATE_AUTH_USER_FAILED,
	payload,
});

export const requestCreateAuthUserSucceeded = payload => ({
	type: CREATE_AUTH_USER_SUCCEEDED,
	payload,
});

export const requestCreateAuthUser = body => {
	return async dispatch => {
		dispatch(createAuthUser());
		const path = `users`;

		return postHandler(path, JSON.stringify(body), null, getAuthHost())
			.then(json => {
				dispatch(requestCreateAuthUserSucceeded(json));
			})
			.catch(error => {
				console.error('requestCreateAuthUser error', error);
				dispatch(requestCreateAuthUserFailed(error));
			});
	};
};

export const refreshConfirmationCode = () => ({
	type: REFRESH_CONFIRMATION_CODE,
});

export const requestRefreshConfirmationCodeFailed = payload => ({
	type: REFRESH_CONFIRMATION_CODE_FAILED,
	payload,
});

export const requestRefreshConfirmationCodeSucceeded = payload => ({
	type: REFRESH_CONFIRMATION_CODE_SUCCEEDED,
	payload,
});

export const requestRefreshConfirmationCode = (body, suppressAuth = false) => {
	return dispatch => {
		dispatch(refreshConfirmationCode());
		const path = 'confirmation_code_refresh';
		return postHandler(path, JSON.stringify(body), null, getAuthHost(), suppressAuth)
			.then(json => {
				dispatch(requestRefreshConfirmationCodeSucceeded(json));
			})
			.catch(error => {
				console.error('requestRefreshConfirmationCodeFailed error', error);
				dispatch(requestRefreshConfirmationCodeFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/authUsers/authUser.action.js